// extracted by mini-css-extract-plugin
export default {"detailPopup":"OrderDetailPopup_detailPopup__JI5tS"};